<div class="section-header-container">
  <h4 class="section-header" data-automation="site-location-label">
    {{ 'site.location' | translate }}
  </h4>
</div>
<div class="details-container">
  <div class="details-row">
    <div class="details-half-row location-container">
      <div id="map-detail" class="map-container">
        <map-view [zoom]="4" [usePanning]="true" [latitude]="site.latitude" [longitude]="site.longitude">
          <map-marker [latitude]="site.latitude" [longitude]="site.longitude"></map-marker>
        </map-view>
      </div>
    </div>
  </div>
</div>

<!--<div class="section-header-container">-->
<!--  <h4 class="section-header" data-automation="current-status-label">-->
<!--    {{ 'current.status' | translate }}-->
<!--  </h4>-->
<!--</div>-->
<!--<div class="details-container">-->
<!--  <div class="details-row">-->
<!--    <div class="details-half-row location-container">-->
<!--      <div id="status-detail" class="status-container">-->
<!--        &lt;!&ndash; Insert new component for the status diagram with meter+building+grid+battery &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--@if (site.configurations) {-->
<!--  <monitor-ui-configuration-table-->
<!--    [configurations]="site"-->
<!--    class="table-container-wrapper"-->
<!--    [ngStyle]="{ 'overflow-y': isFirefox ? 'auto' : 'overlay' }"-->
<!--  ></monitor-ui-configuration-table>-->
<!--} @else {-->
<!--  <div class="subsection-container">-->
<!--    <span class="ml-3">{{ 'site.der.no_data' | translate }}</span>-->
<!--  </div>-->
<!--}-->

<!--<monitor-ui-multi-stat-chart-->
<!--  [entity]="site"-->
<!--  [stats]="[]"-->
<!--  [seriesLabels]="['energy.rates.series']"-->
<!--  [colors]="['000000']"-->
<!--  [chartId]="'energy-rates-chart'"-->
<!--  [titleKey]="'profile.chart.y.axis'"-->
<!--&gt;</monitor-ui-multi-stat-chart>-->
